export default __webpack_public_path__ + "static/media/select-level.a0917b41.jpg";